export const ColumnIcon = ({
  size = 22,
  width = 22,
  height = 22,
  ...props
}: {
  size?: number;
  width?: any;
  height?: any;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size || width}
    height={size || height}
    viewBox="0 0 15 14"
    className={`text-black`}
    fill="currentColor"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.25 0C1.14543 0 0.25 0.89543 0.25 2V12C0.25 13.1046 1.14543 14 2.25 14H12.25C13.3546 14 14.25 13.1046 14.25 12V2C14.25 0.895431 13.3546 0 12.25 0H2.25ZM4.25 5.5V8.5H1.75V5.5H4.25ZM1.75 9.5V12C1.75 12.2761 1.97386 12.5 2.25 12.5H4.25V9.5H1.75ZM5.25 9.5V12.5H8.25V9.5H5.25ZM9.25 9.5V12.5H12.25C12.5261 12.5 12.75 12.2761 12.75 12V9.5H9.25ZM9.25 8.5V5.5H12.75V8.5H9.25ZM8.25 5.5H5.25V8.5H8.25V5.5ZM3.5 3.5C3.91421 3.5 4.25 3.16421 4.25 2.75C4.25 2.33579 3.91421 2 3.5 2H2.5C2.08579 2 1.75 2.33579 1.75 2.75C1.75 3.16421 2.08579 3.5 2.5 3.5H3.5ZM7.5 3.5C7.91421 3.5 8.25 3.16421 8.25 2.75C8.25 2.33579 7.91421 2 7.5 2H6C5.58579 2 5.25 2.33579 5.25 2.75C5.25 3.16421 5.58579 3.5 6 3.5H7.5ZM12.75 2.75C12.75 3.16421 12.4142 3.5 12 3.5H10C9.58579 3.5 9.25 3.16421 9.25 2.75C9.25 2.33579 9.58579 2 10 2H12C12.4142 2 12.75 2.33579 12.75 2.75Z"
      fill="#464F60"
    />
  </svg>
);
